import { Box, IconButton, useTheme } from "@mui/material";

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import BaseCard from "../../../theme/cards/BaseCard";
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import Text from "../../../theme/text/Text";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { getWarehouseLocationLabelData } from "../../../../utils/labelColorText";
import { generateColorFromTitle, generateIconColorFromTitle } from "../../../theme/TabView3/IconColorGenerator";

const ProductExtraFieldsCard = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    let backGround = generateColorFromTitle(props.valueType, theme.palette.mode, 95)
    let foreGround = generateIconColorFromTitle(props.valueType, theme.palette.mode)

    return (
        <BaseCard onClick={props.onClick}>
            <Box>
                <Box>
                    <Box>
                        <Text semibold>{props.name}</Text>
                    </Box>

                    <TopRight>
                        <Box
                            sx={{
                                height:32,
                                px:2,
                                display:"flex",
                                alignItems:'center',
                                fontFamily:"Roboto, sans-serif",
                                fontSize:14,
                                color:foreGround,
                                background:backGround,
                                borderTopRightRadius:12,
                                borderBottomLeftRadius:12,
                                borderBottomRightRadius:6,
                                borderTopLeftRadius:6,
                                fontWeight:500,
                            }}
                        >
                            {t(props.valueType)}
                        </Box>

                    </TopRight>
                </Box>
            </Box>
        </BaseCard>
    )
}

export default ProductExtraFieldsCard;
